const routes = [{
  path: '/report/finance',
  component: () => import('@/views/report/finance'),
  name: 'report-finance',
  meta: {
    title: '财务报表'
  }
}, {
  path: '/report/business',
  component: () => import('@/views/report/business'),
  name: 'report-business',
  meta: {
    title: '业务报表'
  }
}, {
  path: '/report/concise',
  component: () => import('@/views/report/concise'),
  name: 'report-concise',
  meta: {
    title: ''
  }
}, {
  path: '/report/regulation',
  component: () => import('@/views/report/regulation'),
  name: 'report-regulation',
  meta: {
    title: '监管报表'
  }
}, {
  path: '/report/task',
  component: () => import('@/views/insurance/task'),
  name: 'report-task',
  meta: {
    title: '保单管理/任务列表'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/report.js